
import Vue from "vue"
import Contact from './contact/index.vue'
import Menu from './menu/index.vue'
import Avatar from '@/components/avatar/index.vue'
import { mapGetters } from 'vuex'
export default Vue.extend({
	data() {
		return {
			icon: require("@/assets/bell.jpg")
		}
	},
	components: {
		Contact,
		Menu,
		Avatar
	}
	, computed: {
		...mapGetters({
			showMenu: 'menuStore/showMenu',
			user: 'userStore/user'
		})
	}


})
